function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M1.182,4.136c0-1.632,1.323-2.955,2.955-2.955h31.91c0.511,0,0.983,0.142,1.403,0.37 C36.948,0.631,35.984,0,34.863,0H2.955C1.323,0,0,1.323,0,2.955C0,4.076,0.631,5.039,1.551,5.54C1.323,5.12,1.182,4.647,1.182,4.136 z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M1.182,15.364c0-1.632,1.323-2.955,2.955-2.955h31.91c0.511,0,0.983,0.141,1.403,0.369 c-0.501-0.92-1.465-1.551-2.586-1.551H2.955C1.323,11.227,0,12.55,0,14.182c0,1.122,0.631,2.084,1.551,2.585 C1.323,16.348,1.182,15.875,1.182,15.364z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M1.182,26.591c0-1.632,1.323-2.955,2.955-2.955h31.91c0.511,0,0.983,0.142,1.403,0.37 c-0.501-0.92-1.465-1.551-2.586-1.551H2.955C1.323,22.455,0,23.777,0,25.409c0,1.121,0.631,2.084,1.551,2.585 C1.323,27.575,1.182,27.102,1.182,26.591z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  fill: "#FFFFFF",
  d: "M4.136,1.182h31.91C37.678,1.182,39,2.504,39,4.136s-1.322,2.955-2.954,2.955H4.136 c-1.632,0-2.955-1.323-2.955-2.955S2.504,1.182,4.136,1.182z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  fill: "#FFFFFF",
  d: "M4.136,12.409h31.91c1.632,0,2.954,1.323,2.954,2.955s-1.322,2.955-2.954,2.955H4.136 c-1.632,0-2.955-1.323-2.955-2.955S2.504,12.409,4.136,12.409z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  fill: "#FFFFFF",
  d: "M4.136,23.636h31.91c1.632,0,2.954,1.323,2.954,2.955s-1.322,2.955-2.954,2.955H4.136 c-1.632,0-2.955-1.323-2.955-2.955S2.504,23.636,4.136,23.636z"
});

function SvgIconNav(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "39px",
    height: "29.546px",
    viewBox: "0 0 39 29.546",
    enableBackground: "new 0 0 39 29.546",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNav);
export default __webpack_public_path__ + "static/media/icon-nav.8240d2c0.svg";
export { ForwardRef as ReactComponent };